import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    templates: null,
  },
  getters: {
    getTemplateList: state => state.templates,
  },
  mutations: {
    SET_TEMPLATE_LIST(state, list) {
      state.templates = list
    },
  },
  actions: {
    async fetchTemplates({ commit }, params) {
      try {
        commit('SET_TEMPLATE_LIST', [])
        const res = (await axiosIns.get('pricing/templates', { params })).data.data
        commit('SET_TEMPLATE_LIST', res)
      } catch (error) {
        console.log(error)
      }
    },
    createTemplate(_, templateData) {
      return axiosIns.post('pricing/templates', templateData)
    },
    editTemplate(_, { templateId, templateData }) {
      return axiosIns.patch(`pricing/templates/${templateId}`, templateData)
    },
    getTemplate(_, templateId) {
      return axiosIns.get(`pricing/templates/${templateId}`)
    },
    async testTemplate(_, templateData) {
      return axiosIns.post('pricing/versions/calculations/stateless', templateData)
    },
    deleteTemplate(_, templateId) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`pricing/templates/${templateId}`)
          .then(() => {
            resolve()
          }).catch(err => reject(err))
      })
    },
    cloneTemplate(_, templateId) {
      return new Promise((resolve, reject) => {
        axiosIns.post(`pricing/templates/clone/${templateId}`)
          .then(() => {
            resolve()
          }).catch(err => reject(err))
      })
    },
    publishTemplate(_, templatePublishData) {
      return axiosIns.post('pricing/versions/publish', templatePublishData)
    },
  },
}
